import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  ListSubheader,
  MenuItem,
  Typography,
} from "@mui/material";
import { useState } from "react";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import { IBoardMenu } from "../../../types/board";
import { Close } from "@mui/icons-material";
import { useAppSelector } from "src/redux/store";

interface IRenderSelectedGroup {
  board: IBoardMenu;
  moveHandler: (id: string) => {};
  actionType: string;
}
const RenderSelectGroup: React.FC<IRenderSelectedGroup> = ({
  board,
  moveHandler,
  actionType,
}) => {
  //#region variable region

  //handle open listsubheader
  const [open, setOpen] = useState(false);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedStageId, setSelectedStageId] = useState<string>("");

  const selectedCards = useAppSelector<{ cardId: string; cardTitle: string }[]>(
    (state) => state.boardSlice.selectedCard
  );

  // intialised variable to store jsx
  const items: JSX.Element[] = board.stages.map((stage: any) => {
    return (
      <MenuItem
        onClick={() => {
          setSelectedStageId(stage.id);
          setOpenConfirmationModal(true);
        }}
        key={stage.id}
      >
        {stage.name}
      </MenuItem>
    );
  });
  //#endregion

  return (
    <>
      <ListSubheader onClick={() => setOpen(!open)}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <span style={{ color: "rgba(0, 0, 0, 0.85)", fontWeight: "500" }}>
            {board.name}
          </span>
          {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        </div>
      </ListSubheader>
      {open && items}
      <Dialog open={openConfirmationModal} className="smallModel">
        <Box className="smallModel__head" style={{ padding: "12px 16px" }}>
          <Typography variant="h3" className="smallModel__title">
            Confirmation
          </Typography>
          <Button
            className="smallModel__closeBtn"
            onClick={() => {
              setOpenConfirmationModal(false);
            }}
          >
            <Close />
          </Button>
        </Box>

        <Box className="move-ConfirmationContent">
          <Typography className="confirmation-msg">
            Do you want to {actionType} the below selected cards?
          </Typography>
          {selectedCards.map((card: any, index) => {
            return (
              <Typography key={card.cardId} className="confirmation-msg">
                {" "}
                {`${index + 1}. ${card.cardTitle}`}
              </Typography>
            );
          })}
        </Box>

        <DialogActions>
          <Button
            variant="outlined"
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              e.preventDefault();
              setOpenConfirmationModal(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
              e.preventDefault();
              setOpenConfirmationModal(false);
              moveHandler(selectedStageId);
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RenderSelectGroup;
